export enum BonusValue {
  SIXTY = "15",
  SEVENTY = "16",
  SEVENTYFIVE = "21",
  MALUS = "07",
}
